module.exports = __webpack_public_path__ + "img/organizers-banner.61bc0846.jpg";